module.exports = __webpack_public_path__ + "ee94ca2bcc7e813de07646d55440f100.svg";